<button id="regionMenuBtn" type="button" class="gl-btn proc__btn-link proc__vertical__middle" (click)="openSelectorDialog(content)">
    <i class="icon icon__location  margin-icon--right"></i>
    <i class="material-icons icon-place" (click)="openSelectorDialog(content)">place</i>
    <span>Выбор военной прокуратуры</span>
</button>

<ng-template #content let-c="close" let-d="dismiss">
     <div class="modal-header">
        <h4 class="modal-title">Выбор военной прокуратуры</h4>
          <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
     </div>
     <div class="modal-body">
       <ul class="list-group">
         <a class="list-group-item"
            [ngStyle]="{'font-weight': selectedVpo?.id === v.id ? 'bold' : 'inherit' }"
            *ngFor="let v of vpoNames" href="javascript:;" (click)="selectVpo(v); c('Close click')">{{v.name}}</a>
       </ul>
     </div>
     <div class="modal-footer text-center">
      <button type="button" class="btn" (click)="c('Close click')">Закрыть</button>
     </div>
</ng-template>

